import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { useQuery } from '@tanstack/react-query';
import { api } from '../utils/api.js';
import { useAuth } from '../context/AuthContext.jsx';
import StatusBadge from '../components/ui/Badge.jsx';
import Button from '../components/ui/Button.jsx';
import Card from '../components/ui/Card.jsx';
import { formatDate } from '../utils/formatters.js';
import { canCreateGatePass } from '../utils/permissions.js';

export default function ITRListPage() {
  const { user } = useAuth();
  const [page, setPage] = useState(1);
  const { data, isLoading } = useQuery({
    queryKey: ['itrs', page],
    queryFn: () => api.get('/itrs', { params: { page, limit: 20 } }).then(r => r.data.data),
  });

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Internal Transfers</h1>
          <p className="text-sm text-gray-500 mt-0.5">Custody changes without physical gate movement</p>
        </div>
        {canCreateGatePass(user) && <Link to="/itrs/new"><Button icon={Plus}>New ITR</Button></Link>}
      </div>
      <Card>
        {isLoading ? <div className="p-8 text-center text-gray-400">Loading…</div> : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-gray-50 border-b">
                <tr>{['ITR Number','Location','From','To','Status','Date',''].map(h => (
                  <th key={h} className="text-left px-4 py-3 font-medium text-gray-600 text-xs uppercase tracking-wide">{h}</th>
                ))}</tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {(data?.items || []).map(itr => (
                  <tr key={itr.id} className="hover:bg-gray-50">
                    <td className="px-4 py-3 font-mono font-semibold text-teal-700">{itr.number}</td>
                    <td className="px-4 py-3 text-gray-600">{itr.location?.code}</td>
                    <td className="px-4 py-3">{itr.fromParty}</td>
                    <td className="px-4 py-3">{itr.toParty}</td>
                    <td className="px-4 py-3"><StatusBadge status={itr.status} /></td>
                    <td className="px-4 py-3 text-gray-400 text-xs">{formatDate(itr.createdAt)}</td>
                    <td className="px-4 py-3 text-right">
                      <Link to={`/itrs/${itr.id}`} className="text-xs text-teal-600 hover:underline">View →</Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Card>
    </div>
  );
}
